import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = ["id", "disabled", "placeholder", "required", "maxlength", "minlength"];
import { ref, watch } from "vue";
import { isEqual } from "lodash";
import { useFieldControl } from "./useFieldControl";
export default /*@__PURE__*/ _defineComponent({
    __name: 'FieldControlJson',
    props: {
        form: {},
        validation: {},
        field: {},
        fieldId: {},
        data: {}
    },
    emits: [
        'change',
        'focus',
        'blur',
    ],
    setup(__props, { emit: __emit }) {
        const emit = __emit;
        const props = __props;
        const { fieldOptions, emitChange, onFocus, onBlur } = useFieldControl(props, emit, 'FieldControlJson');
        const model = ref(toModel(props.data));
        const invalid = ref(false);
        // the value just emitted comes back as data: the text is only reformatted
        //   if the data differs from what is being typed
        watch(() => props.data, data => {
            if (!isEqual(data, parse(model.value))) {
                model.value = toModel(data);
                invalid.value = false;
            }
        });
        function toModel(data) {
            return (data === undefined || data === null) ? undefined : JSON.stringify(data, null, 2);
        }
        function parse(value) {
            try {
                return value && JSON.parse(value);
            }
            catch (e) {
                return undefined;
            }
        }
        function onInput() {
            let json;
            try {
                json = model.value && JSON.parse(model.value);
                invalid.value = false;
            }
            catch (e) {
                invalid.value = true;
                return;
            }
            emitChange(json);
        }
        return (_ctx, _cache) => {
            return _withDirectives((_openBlock(), _createElementBlock("textarea", {
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((model).value = $event)),
                onInput: onInput,
                onFocus: _cache[1] || (_cache[1] =
                    //@ts-ignore
                    (...args) => (_unref(onFocus) && _unref(onFocus)(...args))),
                onBlur: _cache[2] || (_cache[2] =
                    //@ts-ignore
                    (...args) => (_unref(onBlur) && _unref(onBlur)(...args))),
                id: __props.fieldId,
                disabled: _unref(fieldOptions).disabled ?? undefined,
                placeholder: _unref(fieldOptions).placeholder ?? undefined,
                required: _unref(fieldOptions).required ?? undefined,
                maxlength: _unref(fieldOptions).maxLength ?? undefined,
                minlength: _unref(fieldOptions).minLength ?? undefined,
                class: _normalizeClass(["form__control", { 'form__control--json': true, 'form__control--invalid': invalid.value }])
            }, null, 42, _hoisted_1)), [
                [
                    _vModelText,
                    model.value,
                    void 0,
                    { trim: true }
                ]
            ]);
        };
    }
});
